import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { DealsItems } from '../../shared/menu-items/deals-items';

@Component({
  selector: 'app-deals-vertical-sidebar',
  templateUrl: './deals-vertical-sidebar.component.html',
  styleUrls: []
})

export class DealsSidebarComponent implements OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;


  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>()


  private _mobileQueryListener: () => void;
  status = true;
  showMenu = '';
  itemSelect: number[] = [];
  parentIndex = 0;
  childIndex = 0;
  acc_name = localStorage.getItem('acc_name');
  child_net_code = localStorage.getItem('child_net_code');
  mcm_status = localStorage.getItem('mcm_status');
  app_status = localStorage.getItem('app_status');
  video_status = localStorage.getItem('video_status');
  childnetmenu: boolean = false;
  childnetmenudash: boolean = false;
  ads_id = localStorage.getItem('ads_id');
  adsMenu: boolean = true;
  displayMenu: boolean = true;
  appMenu: boolean = false;
  videoMenu: boolean = false;
  keyIns_id = localStorage.getItem('anlytic_id');
  keyInsightsMenu: boolean = true;
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  subclickEvent(): void {
    this.status = true;
  }
  scrollToTop(): void {
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0
    });
  }

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: DealsItems
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);

  }
  ngOnInit(): void {

    
  }
  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  handleNotify() {
    if (window.innerWidth < 1024) {
      this.notify.emit(!this.showClass);
    }
  }
}
